import React from 'react';
import { withLazyComponent } from './with-lazy-component';

const Component = React.lazy(() => import('../components/birthdate-new'));

export default function (dependencies) {
  const html = (props) => {
    const LazyComponent = withLazyComponent(Component);
    return LazyComponent({ ...props, ...dependencies });
  };
  return {
    html,
    validators: [
      function (state, globalState, config) {
        if (state.error || !state.firstBlurred) {
          return 'error';
        }

        return false;
      },
    ],
    config: {
      behaviour: 'text-input',
    },
  };
}
